import { useEffect, useState } from "react";
import { LogoTransparent } from "../../assets";
import { BlueOutline, BluePlain } from "../ui/Buttons/generic/GenericButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { post } from "services/config";


export function FooterMaximized(){
    
    const [loggedIn, setLoggedIn]= useState<boolean>(!!localStorage.getItem("user"));
    const history= useNavigate();
    const location= useLocation();

    const logout = async () => {
        const withCredentials = !(process.env.REACT_APP_WITH_CREDENTIALS === 'false');

        await post("web/session/destroy", {}, { withCredentials: withCredentials });

        localStorage.removeItem("user");
        localStorage.removeItem("user_uid");

        const domain= window.location.hostname.includes('.fr') ? "portal.wall-of-share.fr": "portal.wall-of-share.com";

        Cookies.remove('session_id', { path: '/', domain: domain });

        setLoggedIn(false);

        history('/');
    };

    useEffect(()=> {
        setLoggedIn(!!localStorage.getItem("user"));
    }, []);

    const portalPath= window.location.hostname.includes('.fr') ? "https://portal.wall-of-share.fr/web": "https://portal.wall-of-share.com/web";

    return (
        <footer className="bg-[#1D1D39]  pb-4 pt-14 xl:px-0 px-8">
            <div className="max-w-[1900px] mx-auto flex flex-col xl:flex-row xl:justify-between border-b border-[#BBBBC4] pb-8 xl:w-3/4 xl:mx-auto">
                <div className="xl:w-[14rem] space-y-3 xl:my-5">
                    <img src={LogoTransparent} alt="wos logo" />
                    <div className="text-[#BBBBC4]  text-start text-[16px] xl:text-[14px] xl:w-10/12">
                        Connectez-vous à notre plateforme et découvrez des talents internationaux à un coût mensuel avantageux.
                    </div>
                </div>

                <div className="flex-1 lg:flex my-6">
                    <div className="mt-.5 flex-1 xl:flex justify-start xl:my-0 my-4 lg:my-0 text-[16px] xl:text-[14px]">
                        <div className="space-y-3">
                            <div className="text-[#BBBBC4] text-start">Je veux recruter</div>
                            <ul className="m-0 p-0 text-white ">
                                <li><Link to={"/comment-ca-marche-entreprises"} className="hover:text-[#BBBBC4]">Comment ça marche ?</Link></li>
                                <li><Link to={"/plateforme-freelance"} className="hover:text-[#BBBBC4]">Nos freelances</Link></li>
                                <li><Link to={"/parcours-entreprise"} className="hover:text-[#BBBBC4]">Inscription entreprise</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="mt-.5 flex-1 xl:flex justify-start xl:my-0 my-4 lg:my-0 text-[16px] xl:text-[14px]">
                        <div className="space-y-3">
                            <div className="text-[#BBBBC4] text-start">Je veux travailler</div>
                            <ul className="m-0 p-0 text-white">
                                <li><Link to={"/comment-ca-marche-freelances"} className="hover:text-[#BBBBC4]">Comment ça marche ?</Link></li>
                                <li><Link to={"/prestations-entreprises"} className="hover:text-[#BBBBC4]">Les services</Link></li>
                                <li><Link to={"/parcours-freelance"} className="hover:text-[#BBBBC4]">Inscription freelance</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="mt-.5 flex-1 xl:flex justify-start xl:my-0 my-4 lg:my-0 text-[16px] xl:text-[14px]">
                        <div className="space-y-3">
                            <div className="text-[#BBBBC4] text-start">Wall of Share</div>
                            <ul className="m-0 p-0 text-white">
                                <li><Link to={"/a-propos"} className="hover:text-[#BBBBC4]">À propos</Link></li>
                                <li><Link to={"/contactez-nous"} className="hover:text-[#BBBBC4]">Contactez-nous</Link></li>
                                <li><Link to={"/protection-des-donnees"} className="hover:text-[#BBBBC4]">Protection des données</Link></li>
                                <li><Link to={"/mentions-legales"} className="hover:text-[#BBBBC4]">Mentions Légales</Link></li>
                                <li><Link to={"/conditions-generales-d-utilisation"} className="hover:text-[#BBBBC4]">Conditions générales d'utilisation</Link></li>
                            </ul>
                        </div>
                    </div>

                    {
                        loggedIn ?
                            <>
                                <div className="mt-.5 flex-1 xl:flex justify-start xl:my-0 my-4 lg:my-0 text-[16px] xl:text-[14px] ml-auto">
                                    <div className="space-y-3">
                                        <div className="text-[#BBBBC4] text-start">Mon profil</div>
                                        <ul className="m-0 p-0 text-white">
                                            <li><Link to={"/profil"} className="hover:text-[#BBBBC4]">Mon profil</Link></li>
                                            <li><Link to={portalPath} className="hover:text-[#BBBBC4]">Mon portail</Link></li>
                                            <li><Link to={"#"} className="hover:text-[#BBBBC4]" onClick={logout}>Déconnexion</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </>
                        :
                        <div className="flex flex-col gap-2">
                            <BluePlain
                                text="S'inscrire"
                                isButton= {false}
                                className="font-semibold py-[5px] px-[10px] text-[14px] leading-[15.8px]"
                                to={'/inscription'}
                            />
                            <BlueOutline
                                text="Se connecter"
                                isButton={false}
                                className="font-semibold py-[5px] px-[10px] text-[14px] leading-[15.8px]"
                                to={'/connexion'}
                            />
                    </div>}
                </div>

            </div>
            <div className="text-[#BBBBC4] text-center mt-4 mb-12 text-[16px] xl:text-[14px]">{(new Date()).getFullYear()} © Wall Of Share Tous droits réservés</div>
        </footer>
    )
}

export default function Footer(){
    return (
        <footer className="bg-[#1D1D39]  pb-4 pt-14 xl:px-0 px-8">
            <div className="text-[#BBBBC4] text-center mt-4 mb-12 text-[16px] xl:text-[14px]">{(new Date()).getFullYear()} © Wall Of Share Tous droits réservés</div>
        </footer>
    )
}